/* @flow */

export const DIGIT_INITIAL_VALUE = '';

export enum CodeDisplayType {
  Hidden,
  Visible,
}
